import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SITE } from "@/content/site";

export default function Datenschutz() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1" data-testid="legal-page-wrapper">
        <div className="site-container section-pad max-w-3xl">
          <p className="kicker">Rechtliches</p>
          <h1 className="mt-4 text-3xl font-semibold tracking-[-0.02em] sm:text-4xl" data-testid="datenschutz-title">
            Datenschutzerklärung
          </h1>

          <div className="mt-10 space-y-8 text-sm leading-relaxed text-foreground/85">
            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">1. Verantwortliche Stelle</h2>
              <p className="mt-3">
                {SITE.name}
                <br />
                {SITE.owner}
                <br />
                {SITE.addressLine1}
                <br />
                {SITE.addressLine2}
                <br />
                Schweiz
                <br />
                E-Mail: {SITE.email}
                <br />
                Telefon: {SITE.phoneDisplay}
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">2. Grundsätzliches</h2>
              <p className="mt-3">
                Wir bearbeiten Personendaten gemäss dem schweizerischen Datenschutzgesetz (revDSG / nDSG).
                Soweit die europäische Datenschutz-Grundverordnung (DSGVO) anwendbar ist, beachten wir deren Vorgaben.
                Personendaten werden nur so weit bearbeitet, wie es für den Betrieb dieser Website, die Bearbeitung von
                Anfragen und die Erfüllung gesetzlicher Pflichten erforderlich ist.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">3. Hosting</h2>
              <p className="mt-3">
                Diese Website wird bei Netlify, Inc., 44 Montgomery Street, Suite 300, San Francisco, CA 94104, USA,
                gehostet. Beim Besuch der Website werden automatisch technische Log-Daten verarbeitet (u. a. IP-Adresse,
                Datum und Uhrzeit des Zugriffs, angeforderte Dateien, Browser- und Betriebssysteminformationen).
                Die Verarbeitung dient der sicheren und stabilen Bereitstellung der Website und der Abwehr von Missbrauch.
              </p>
              <p className="mt-3">
                Netlify kann Server in den USA oder der EU betreiben. Bei einer Übermittlung in die USA erfolgt diese
                gestützt auf geeignete Garantien (z. B. Standardvertragsklauseln) bzw. im Rahmen der betrieblichen
                Notwendigkeit.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">4. Kontaktformular (Netlify Forms)</h2>
              <p className="mt-3">
                Wenn Sie uns über das Kontaktformular eine Anfrage senden, werden die von Ihnen angegebenen Daten
                (Name, optional Telefonnummer, E-Mail-Adresse, Anliegen, Nachricht) zur Bearbeitung Ihrer Anfrage und
                für mögliche Rückfragen gespeichert und an uns übermittelt.
              </p>
              <p className="mt-3">
                Die Übermittlung und Zwischenspeicherung erfolgt über Netlify Forms (Netlify, Inc., USA).
                Die Daten werden nur zur Bearbeitung Ihrer Anfrage verwendet und nicht ohne Ihre Einwilligung an
                Dritte weitergegeben. Nach abgeschlossener Bearbeitung und unter Beachtung gesetzlicher
                Aufbewahrungspflichten werden die Daten gelöscht.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">5. Web-Analyse (PostHog)</h2>
              <p className="mt-3">
                Zur Analyse der Nutzung unserer Website und zur Verbesserung unseres Angebots setzen wir den Dienst
                PostHog (PostHog Inc., USA) ein. PostHog kann dabei u. a. folgende Informationen erfassen:
                Seitenaufrufe, Verweildauer, Klickverhalten, technische Geräte- und Browserdaten sowie eine
                pseudonyme Besucherkennung (z. B. über Cookies oder Local Storage).
              </p>
              <p className="mt-3">
                Die Auswertung erfolgt in aggregierter bzw. pseudonymer Form. Eine Identifikation einzelner Personen
                ist für uns nicht vorgesehen. Die Datenverarbeitung dient unserem berechtigten Interesse an der
                Optimierung und Stabilität der Website.
              </p>
              <p className="mt-3">
                Weitere Informationen:{" "}
                <a
                  href="https://posthog.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[hsl(var(--brand-steelblue))] underline-offset-2 hover:underline"
                >
                  posthog.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">6. Schriften (Google Fonts)</h2>
              <p className="mt-3">
                Zur einheitlichen Darstellung von Schriftarten binden wir Google Fonts ein (Google Ireland Limited /
                Google LLC). Beim Laden der Seite kann Ihr Browser eine Verbindung zu Servern von Google herstellen
                und dabei Ihre IP-Adresse übermitteln.
              </p>
              <p className="mt-3">
                Die Einbindung erfolgt zur ansprechenden und einheitlichen Darstellung unserer Website.
                Weitere Informationen:{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[hsl(var(--brand-steelblue))] underline-offset-2 hover:underline"
                >
                  policies.google.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">7. Cookies und ähnliche Technologien</h2>
              <p className="mt-3">
                Unsere Website kann Cookies sowie vergleichbare Technologien (z. B. Local Storage) einsetzen –
                insbesondere im Zusammenhang mit dem Hosting und der Nutzung von PostHog. Technisch notwendige
                Daten werden für den Betrieb der Seite benötigt. Analysebezogene Speicherung dient der Messung und
                Verbesserung der Website-Nutzung.
              </p>
              <p className="mt-3">
                Sie können Cookies in den Einstellungen Ihres Browsers einschränken oder löschen. Dadurch können
                einzelne Funktionen der Website eingeschränkt sein.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">8. Ihre Rechte</h2>
              <p className="mt-3">
                Nach dem schweizerischen Datenschutzgesetz haben Sie insbesondere folgende Rechte:
              </p>
              <ul className="mt-3 list-disc space-y-1.5 pl-5">
                <li>Recht auf Auskunft über die zu Ihrer Person bearbeiteten Daten</li>
                <li>Recht auf Berichtigung unrichtiger Daten</li>
                <li>Recht auf Löschung, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen</li>
                <li>Recht auf Herausgabe bzw. Übertragung Ihrer Daten (Datenportabilität), soweit anwendbar</li>
                <li>Recht, der Bearbeitung zu widersprechen, soweit die Bearbeitung auf unserem berechtigten Interesse beruht</li>
              </ul>
              <p className="mt-3">
                Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: {SITE.email}
              </p>
              <p className="mt-3">
                Zudem haben Sie das Recht, sich beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten
                (EDÖB) zu beschweren:{" "}
                <a
                  href="https://www.edoeb.admin.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[hsl(var(--brand-steelblue))] underline-offset-2 hover:underline"
                >
                  www.edoeb.admin.ch
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">9. Aufbewahrung</h2>
              <p className="mt-3">
                Anfragen über das Kontaktformular werden gelöscht, sobald sie vollständig bearbeitet sind und keine
                gesetzlichen Aufbewahrungspflichten (z. B. aus dem Obligationenrecht bei Geschäftsunterlagen)
                entgegenstehen. Technische Log- und Analysedaten werden nur so lange aufbewahrt, wie es für die
                genannten Zwecke erforderlich ist.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold tracking-[-0.01em] text-foreground">10. Änderungen</h2>
              <p className="mt-3">
                Wir können diese Datenschutzerklärung anpassen, wenn sich unsere Prozesse oder die Rechtslage ändern.
                Die aktuelle Fassung ist jeweils auf dieser Seite veröffentlicht.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
